<template>
    <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                    <!--<img src="/static/img/logo.png" class="center-block logo">-->
                    <h1>You are lost.</h1>
                    <h4>This page doesn't exist.</h4>
                    <router-link to="/" class="vertical-5p lead">Take me home.</router-link>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>


<script>
    export default {
        name: 'NotFound'
    }
</script>

<style scoped>

</style>